/* _customled-article-lightbox.js - full-size (desktop) / fitted+pinch (mobile)
   click-to-enlarge for a.cl-lightbox article images. Native <dialog>.
   rev6 2026-07-16: circle close button matching the PDP media-modal toggle;
   visual-viewport pin (synchronous, sized off the button) so it never drifts
   under pinch. No-JS/no-dialog fallback: anchor opens the image in a new tab. */
(function () {
  'use strict';
  var CLOSE_SVG = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18"/></svg>';
  var dlg, btn;
  function pinButton() {
    if (!dlg || !dlg.open || !window.visualViewport) return;
    var vv = window.visualViewport;
    var s = 1 / vv.scale;
    var bw = btn.offsetWidth || 40;
    var m = 12 * s;
    var tx = vv.offsetLeft + vv.width - (bw * s) - m;
    var ty = vv.offsetTop + m;
    btn.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + s + ')';
  }
  function build() {
    dlg = document.createElement('dialog');
    dlg.className = 'cl-lightbox-dialog';
    btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'cl-lightbox-close';
    btn.setAttribute('aria-label', 'Close image viewer');
    btn.innerHTML = CLOSE_SVG;
    var img = document.createElement('img');
    img.alt = '';
    dlg.appendChild(btn);
    dlg.appendChild(img);
    document.body.appendChild(dlg);
    dlg.addEventListener('click', function (ev) { if (ev.target === img) return; dlg.close(); });
    if (window.visualViewport) {
      btn.style.top = '0'; btn.style.left = '0'; btn.style.right = 'auto';
      btn.style.transformOrigin = 'top left'; btn.style.willChange = 'transform';
      window.visualViewport.addEventListener('resize', pinButton);
      window.visualViewport.addEventListener('scroll', pinButton);
    }
    return dlg;
  }
  document.addEventListener('click', function (ev) {
    var a = ev.target && ev.target.closest ? ev.target.closest('a.cl-lightbox') : null;
    if (!a) return;
    if (!('HTMLDialogElement' in window)) return;
    ev.preventDefault();
    if (!dlg) build();
    var srcImg = a.querySelector('img');
    var im = dlg.querySelector('img');
    im.src = a.getAttribute('href');
    im.alt = srcImg ? (srcImg.getAttribute('alt') || '') : '';
    dlg.setAttribute('aria-label', im.alt || 'Image viewer');
    dlg.showModal();
    dlg.scrollTop = 0; dlg.scrollLeft = 0;
    pinButton();
  });
})();
